/**
 * site_search collector'i.
 * Kaynaklar: URL'deki arama parametresi (q, s, search, query ...), hash icindeki
 * parametre (SPA: #/search?q=...), yol tabanli arama (/arama/iphone%2018/,
 * bkz. searchPath.js) ve sayfadaki arama formunun submit'i.
 * "Insanlar ne ariyor ve bulamiyor" raporunun tek veri kaynagi.
 */
import { AUTO_EVENTS } from "../events";
import trackerConfig from "../config";
import { extractSearchFromPath } from "./searchPath";

const RESULT_COUNT_SELECTORS = [
    "[data-supsis-results]",
    "[data-result-count]",
    ".search-result-count",
    ".results-count",
];

class SiteSearchCollector {
    constructor(tracker) {
        this.tracker = tracker;
        this.lastQuery = "";
    }

    start() {
        const self = this;
        this.checkUrl();

        document.addEventListener(
            "submit",
            function (event) {
                try {
                    self.onSubmit(event);
                } catch (e) {
                    /* yoksay */
                }
            },
            true
        );
    }

    /** SPA gecislerinde de cagrilir (tracker page_view sonrasi). */
    checkUrl() {
        try {
            const keys = trackerConfig.siteSearchParams;

            // 1) Query parametresi: ?q=iphone
            let value = this.readParams(window.location.search, keys);
            // 2) Hash icindeki parametre: #q=iphone veya #/search?q=iphone
            if (!value) value = this.readParams(window.location.hash, keys);
            if (value) {
                this.emitSearch(value, "url");
                return;
            }

            // 3) Yol tabanli arama: /arama/iphone%2018/ (ayar + varsayilan kaliplar)
            const fromPath = extractSearchFromPath(window.location.pathname, trackerConfig.siteSearchPaths);
            if (fromPath) this.emitSearch(fromPath, "path");
        } catch (e) {
            /* yoksay */
        }
    }

    /** "?a=1&q=x" ya da "#/search?q=x" gibi bir parcadan arama parametresini okur. */
    readParams(raw, keys) {
        const text = String(raw || "");
        const start = text.indexOf("?") !== -1 ? text.indexOf("?") + 1 : text.charAt(0) === "#" ? 1 : 0;
        const params = new URLSearchParams(text.slice(start));
        for (let i = 0; i < keys.length; i++) {
            const value = params.get(keys[i]);
            if (value && value.trim()) return value.trim();
        }
        return "";
    }

    onSubmit(event) {
        const form = event.target;
        if (!form || (form.tagName || "").toLowerCase() !== "form") return;

        const isSearchForm =
            form.getAttribute("role") === "search" ||
            (form.className && /search/i.test(String(form.className))) ||
            !!form.querySelector('input[type="search"]');
        if (!isSearchForm) return;

        const input =
            form.querySelector('input[type="search"]') ||
            form.querySelector('input[name="q"]') ||
            form.querySelector('input[name="s"], input[name="search"], input[name="query"], input[name="arama"], input[name="keyword"], input[name="k"]') ||
            form.querySelector('input[type="text"]');
        if (!input || !input.value || !input.value.trim()) return;

        this.emitSearch(input.value.trim(), "form");
        this.tracker.flush("site_search");
    }

    /** Sonuc sayisi sayfada isaretlenmisse rapora eklenir. */
    resultCount() {
        for (let i = 0; i < RESULT_COUNT_SELECTORS.length; i++) {
            try {
                const node = document.querySelector(RESULT_COUNT_SELECTORS[i]);
                if (!node) continue;
                const raw = node.getAttribute("data-supsis-results") || node.getAttribute("data-result-count") || node.textContent;
                const parsed = parseInt(String(raw).replace(/[^0-9]/g, ""), 10);
                if (!isNaN(parsed)) return parsed;
            } catch (e) {
                /* yoksay */
            }
        }
        return null;
    }

    emitSearch(query, source) {
        const normalized = query.slice(0, 200);
        if (normalized === this.lastQuery) return;
        this.lastQuery = normalized;

        const count = this.resultCount();
        const props = { query: normalized, source: source };
        if (count !== null) props.results_count = count;

        this.tracker.emit(AUTO_EVENTS.SITE_SEARCH, props, {
            search: { query: normalized, resultsCount: count === null ? undefined : count },
        });
    }
}

export default SiteSearchCollector;



//////////////////
// WEBPACK FOOTER
// ./static/src/tracker/collectors/siteSearch.js
// module id = null
// module chunks = 